import React, { ChangeEvent, FunctionComponent } from 'react';

import {
  CoverType,
  InsuranceName,
  SingleSegmentedControlStepProps,
} from 'scenes/common/types';
import { toPercentage } from 'scenes/common/helpers/percentage';
import { combinedPolicyDiscount } from 'scenes/common/helpers/insuranceInfo';
import Disclaimer from 'scenes/common/components/Disclaimer/Disclaimer';

import SingleSegmentedControlStep from '../SingleSegmentedControlStep';

const getHelpText = (
  insuranceName: InsuranceName,
  helpText?: string | JSX.Element
) => {
  if (helpText) return helpText;
  if (combinedPolicyDiscount(insuranceName) > 0)
    return `Get a ${toPercentage(
      combinedPolicyDiscount(insuranceName)
    )} discount by combining building and contents (subject to minimum premiums).`;
  return undefined;
};

const STATE_KEY = 'coverType';

const CoverTypeSelectionStep: FunctionComponent<
  Pick<
    SingleSegmentedControlStepProps<string, CoverType>,
    'defaultStateValue' | 'onNext' | 'question' | 'options'
  > & {
    insuranceName: InsuranceName;
    helpText?: string | JSX.Element;
    onChangeCallback?: (e: ChangeEvent<HTMLInputElement>) => void;
  }
> = ({
  onNext,
  defaultStateValue,
  question,
  options,
  insuranceName,
  helpText,
  onChangeCallback,
}) => (
  <>
    <SingleSegmentedControlStep
      stack
      onNext={onNext}
      options={options}
      question={question}
      stateKey={STATE_KEY}
      helpText={getHelpText(insuranceName, helpText)}
      defaultStateValue={defaultStateValue}
      onChangeCallback={onChangeCallback}
    />
    <Disclaimer />
  </>
);

export default CoverTypeSelectionStep;
